  import { GoogleLogin } from '@react-oauth/google'
import React from 'react'
import SignUpForm from './Signuppage'
import LogInForm from './LoginPage'
import ForgotPasswordScreens from './Forgotpassword'
import { useState } from 'react'
import RightBlock from '../../components/signUpLatyout/RightBlock'
import OrLine from '../../components/common/OrLine'
import { DesktopLoginViewtalwind, mobileLoginViewtalwind } from './MobileLoginTalwind'

  
  export default function DesktopLoginView({
    formGreetings,
    formSubGreetings,
    responseMessage,
    errorMessage,
    runOneSignal,
    formType

  }){
    const [FPWDSec, setFPWDSec] = useState(false);
    const BacktoSignin =()=>{
      setFPWDSec(false);
  }
    return(
        <section className="sign-in w-full h-full  overflow-hidden flex justify-center bg-white">

        {
          !FPWDSec ? (
            <div className={DesktopLoginViewtalwind.LeftContainer}>
              <div className={mobileLoginViewtalwind.btmHeadCon}>
                <img
                  src={require('../../Assets/odds_logo_blue.png')}
                  className="h-[52px]"
                />
                <h1 className={mobileLoginViewtalwind.baseHeading}>
                  {formGreetings}
                </h1>
                <p className={mobileLoginViewtalwind.secondBaseHead}>
                  {formSubGreetings}
                </p>
                <div className='mt-1'>
                  <GoogleLogin text='continue_with'
                    onSuccess={responseMessage} onError={errorMessage} />
                </div>
              </div>
              <OrLine />
              <div className='w-full'>
                {formType == 'SIGNUP' ? (<SignUpForm runOneSignal={runOneSignal} />) : (<LogInForm runOneSignal={runOneSignal} setFPWDSec={setFPWDSec} />)}
              </div>
            </div>
          ) : (
            <div className={DesktopLoginViewtalwind.LeftContainer}>
              <div className={mobileLoginViewtalwind.btmHeadCon}>
                <img
                  src={require('../../Assets/odds_logo_blue.png')}
                  className="h-[52px]"
                />
              </div>

              <ForgotPasswordScreens
               BacktoSignin={()=>{BacktoSignin()}}
              />
            </div>
          )


        }

        <RightBlock />
      </section>
    )
  }
 